import React from 'react'
import left from '../Assets/Images/leftArrow.svg'
import right from '../Assets/Images/rightArrow.svg'

/**
 * Custom pagination item renderer.
 * Replaces 'prev' and 'next' buttons with custom arrow images.
 */
export const itemRender = (current, type, originalElement) => {
  if (type === "prev") {
    return <img className="prev-arrow" src={left} alt="previous" />;
  }
  if (type === "next") {
    return <img className="next-arrow" src={right} alt="next" />;
  }
  return originalElement;
};
